import axios from '../../config/axios';

export const ordersApi = {
    // دالة جديدة آمنة لجلب طلبات المستخدم فقط
    getUserOrders: async (type) => {
        try {
            // Fetching user orders of type
            const response = await axios.get(`/api/user/my-orders?type=${type}`);
            // User orders API response received
            return response.data;
        } catch (error) {
            // Get user orders error
            throw error;
        }
    },

    // هذه الدالة غير آمنة - تجلب جميع الطلبات في النظام!
    getAllOrders: async (type) => {
        try {
            // Fetching all orders of type
            const response = await axios.get(`/api/orders?type=${type}`);
            // Orders API response received
            return response.data;
        } catch (error) {
            // Get all orders error
            throw error;
        }
    },

    submitOrder: async (orderData) => {
        try {
            // Sending order data
            const response = await axios.post('/api/orders/submit', orderData);
            // Order API response received
            return response.data;
        } catch (error) {
            // طباعة الـ validation errors
            if (error.response && error.response.status === 422) {
                // Validation errors in response
            }
            // Order API error
            throw error;
        }
    },

    uploadReceipt: async (formData) => {
        try {
            const response = await axios.post('/api/orders/upload-receipt', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            // Upload receipt error
            throw error;
        }
    },

    getOrder: async (orderId) => {
        try {
            const response = await axios.get(`/api/orders/${orderId}`);
            return response.data;
        } catch (error) {
            // Get order error
            throw error;
        }
    },

    updateOrderStatus: async (orderId, status, type) => {
        try {
            const response = await axios.post(`/api/orders/${orderId}/status`, { status, type });
            return response.data;
        } catch (error) {
            // Update order status error
            throw error;
        }
    },

    // حذف طلب
    deleteOrder: async (orderId, type) => {
        try {
            const response = await axios.delete(`/api/orders/${orderId}?type=${type}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getInstallmentPlan: async (courseId, totalAmount) => {
        try {
            const response = await axios.get('/api/installments/plan', {
                params: { course_id: courseId, total_amount: totalAmount }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getInstallmentDetails: async (orderId) => {
        try {
            const response = await axios.get(`/api/installments/details/${orderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    checkOverdue: async () => {
        try {
            const response = await axios.get('/api/installments/check-overdue');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    payInstallment: async (planId, mode) => {
        try {
            const response = await axios.post('/api/installments/pay', { plan_id: planId, mode });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};
